/*
 * @Author: Lucas Fridez
 * @Date: 2019-09-06 07:58:39
 * @LastEditors: Lucas Fridez
 * @LastEditTime: 2019-09-06 10:33:09
 * @Description: file content
 */
import * as types from "./ActionsCategoriesReducer";

export default function categoriesReducer(
    state = {
        categories: [],
        location: "0"
    }, action) {
    switch (action.type) {
        case types.CATEGORIES_UPDATE:
            state.categories = action.value;
            break;
        case types.LOCATION_UPDATE:
            state.location = action.value;
            break;
    }

    return { ...state };
}



// WEBPACK FOOTER //
// ./src/app/store/reducers/categories/CategoriesReducer.ts